import type { Prompt, PromptFolder } from ".";

export type ParsingPrompts = SummarizePrompt | SummarizeImagePrompt | SummarizeTablePrompt;

/* eslint-disable @typescript-eslint/naming-convention */
export const parsingPromptFolders = {
	summarize: "parsing",
	"summarize-image": "parsing",
	"summarize-table": "parsing",
} as const satisfies Record<ParsingPrompts["name"], PromptFolder>;
/* eslint-enable @typescript-eslint/naming-convention */

export interface SummarizePrompt extends Prompt {
	name: "summarize";
	variables: {
		title: string;
		content: string;
		date: string;
		path?: string | undefined;
	};
}

export interface SummarizeImagePrompt extends Prompt {
	name: "summarize-image";
	variables: {
		title: string;
		summary: string;
		headers: string;
		date: string;
	};
}

export interface SummarizeTablePrompt extends Prompt {
	name: "summarize-table";
	variables: {
		title: string;
		summary: string;
		headers: string;
		table: string;
		date: string;
	};
}
